<template>
  <div class="fashion-android-container">
    <h1>元邦時尚家 Android</h1>
  </div>
</template>

<script>
export default {
  name: 'FashionAndroid',
  mounted() {
    // 页面加载后直接跳转到Google Play
    window.location.href = 'https://play.google.com/store/apps/details?id=com.Inventec.IBC.VRStateFashion'
  }
}
</script>

<style scoped>
.fashion-android-container {
  padding: 20px;
  text-align: center;
}

h1 {
  color: #3ddc84;
  margin-bottom: 20px;
}
</style>
